import { render, staticRenderFns } from "./OneSelected.vue?vue&type=template&id=20e5a12b&scoped=true&"
import script from "./OneSelected.vue?vue&type=script&lang=js&"
export * from "./OneSelected.vue?vue&type=script&lang=js&"
import style0 from "./OneSelected.vue?vue&type=style&index=0&id=20e5a12b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e5a12b",
  null
  
)

export default component.exports